import React from "react";
import "./services.scss";

import HeaderImage from "../assets/graphics/_3.png";
import ServiceImage from "../assets/graphics/_4.png";

import Etl1Icon from "../assets/icons/etl1.png";
import Etl2Icon from "../assets/icons/etl2.png";
import Etl3Icon from "../assets/icons/etl3.png";
import { ContactForm } from "../components/ContactForm";

import PlanningImg from "../assets/graphics/planning.svg";
import DeploymentImg from "../assets/graphics/deployment.svg";
import DevelopmentImg from "../assets/graphics/development.svg";

export function Services(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div>
        <header className="page-header">
          <div>
            <h3 className="white mainSubhead">
              Redefining ERP implementations with real-world manufacturing
              experience.
            </h3>
          </div>
          <div className="img-container">
            <img
              src={HeaderImage}
              className="header-img"
              alt="ERP Implementation"
            />
          </div>
        </header>
      </div>

      <div>
        <div className="container">
          <h3 className="mainSubhead centre">
            ERP Implementation Professional Services.
          </h3>
          <p className="body-text">
            The Alpaca approach to ERP implementation is unique. Because of our
            deep experience in manufacturing, we apply a common-sense approach
            that simplifies the process and brings confidence to clients.
          </p>
        </div>

        <div className="grid-container-services">
          <div className="img-container-services">
            <img src={ServiceImage} alt="ERP Implementation" />
          </div>
          <div className="standardContainer">
            <p className="body-text left">
              We begin with an in-depth analysis of your business, including:
            </p>
            <ul className="services-list">
              <li>Discovery meetings with key stakeholders</li>
              <li>On-site visit to your facility</li>
              <li>Developing an implementation strategy</li>
              <li>Full configuration and data migration</li>
              <li>Testing and remote training</li>
              <li>Go-live before and after support</li>
            </ul>
          </div>
        </div>

        <div className="standardContainer">
          <div className="alpaca-transform-header-container">
            <h3 className="mainSubhead centre">Alpaca Transform</h3>
            <p className="body-text">
              The hardest part of any ERP implementation is data transfer.
              Alpaca Transform simplifies the process and cuts down the data
              extraction, transformation, and load timeline from{" "}
              <strong>6 months to 1 month</strong> by actively involving the
              data owners in the process.
            </p>
          </div>
          <div className="alpaca-transform-grid-container">
            <div className="alpaca-transform-grid-item">
              <img src={Etl1Icon} alt="Extract" />
              <h5 className="smallSubhead">Extract</h5>
            </div>
            <div className="alpaca-transform-grid-item">
              <img src={Etl2Icon} alt="Transfer" />
              <h5 className="smallSubhead">Transfer</h5>
            </div>
            <div className="alpaca-transform-grid-item">
              <img src={Etl3Icon} alt="Load" />
              <h5 className="smallSubhead">Load</h5>
            </div>
          </div>
        </div>

        <div className="service-info">
          <div>
            <p className="body-text white">
              The on-site analysis not only allows us to become intimate with
              your workflows and better understand your costing, it enables us
              to bridge the fundamental disconnect that exists between your
              accounting, finance and operations teams by giving you and your
              team a clear map of how your manufacturing operations flow through
              the ERP, and ultimately through to your financial statements. The
              full configuration, data migration, testing, and remote training
              that follow are all performed off-site, allowing you to focus on
              your operations. Finally, go-live is fully supported by the Alpaca
              team onsite.
            </p>
            <a href="/contact">
              <button className="main-btn">Learn More</button>
            </a>
          </div>
        </div>
      </div>

      <div className="our-process-container">
        <h2 className="mainSubhead">Our Process</h2>
        <p className="body-text">We simplified the development process</p>
        <div className="our-process-grid">
          <div className="our-process-grid-item">
            <img
              src={PlanningImg}
              alt="Discovery"
              className="our-process-illustration"
            />
            <div>
              <h3 className="smallSubhead">Discovery</h3>
              <p className="body-text">
                Our process begins with a conversation with key stakeholders,
                ensuring they understand how Dynamics or other software serve
                the unique and individual needs of your business.
              </p>
            </div>
          </div>

          <div className="our-process-line-container">
            <div className="our-process-dashed-line"></div>
          </div>

          <div className="our-process-grid-item">
            <img
              src={DeploymentImg}
              alt="Site Visits"
              className="our-process-illustration our-process-width"
            />
            <div>
              <h3 className="smallSubhead">Site Visits</h3>
              <p className="body-text">
                No two manufacturing facilities are alike. After the discovery
                session, our team will arrange a site visit to see your
                manufacturing facility first-hand.
              </p>
            </div>
          </div>

          <div className="our-process-line-container">
            <div className="our-process-dashed-line"></div>
          </div>

          <div className="our-process-grid-item">
            <img
              src={DevelopmentImg}
              alt="Strategy"
              className="our-process-illustration"
            />
            <div>
              <h3 className="smallSubhead">Strategy</h3>
              <p className="body-text">
                From there, the Alpaca team of manufacturing experts,
                developers, solution architects and software experts get to work
                designing your ERP strategy and program.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ContactForm />
    </>
  );
}
